let shellIntroComplete = false;

export function shouldPlayShellIntro() {
    return !shellIntroComplete;
}

export function markShellIntroComplete() {
    shellIntroComplete = true;
}
